module.exports = __webpack_public_path__ + "media/images/pages/i-belong/pete-4f4c0f71648d7ff8646bf44de1182948.png";